import { ChipsideComponent } from "../chipside-component";

export class SortableListItem extends ChipsideComponent {
	constructor() {
		super();

		this.identifier = this.getAttribute("identifier") ?? "";
	}
}